<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SettingsTabs from './SettingsTabs.vue';

const { t } = useI18n();

const emit = defineEmits<{
   onClose: [];
}>();

//#region Tabs
const selectedTab = ref<string | null>(null);
</script>

<template>
   <Transition name="fade">
      <NxtSideModal :title="t('settings.settings', 2)" :width="'92.3rem'" class="settings" @on-close="emit('onClose')">
         <div class="settings">
            <SettingsTabs @on-tab-change="selectedTab = $event" />
            <div class="settings__main">
               <h2>{{ selectedTab }}</h2>
               <!-- <SettingsGeneral v-if="selectedTab === $t('generic.general')" /> -->
               No Settings Yet
            </div>
         </div>
      </NxtSideModal>
   </Transition>
</template>

<style lang="scss" scoped>
.settings {
   display: flex;
   width: 100%;
   height: 100%;
   gap: toRem(48);
   &__main {
      width: 100%;
      position: relative;
      h2 {
         margin: unset;
         margin-top: toRem(8);
         margin-bottom: toRem(24);
      }
   }
}
</style>
